import storageKeys from './storage-keys';

export const getItem = (key = storageKeys.oat) => {
  try {
    const localStorageData = localStorage.getItem(key);
    if (!localStorageData) return undefined;
    const storage = JSON.parse(localStorageData);
    return storage || undefined;
  } catch (e) {
    return undefined;
  }
};

export const setItem = (value, key = storageKeys.oat) => {
  const existingState = getItem(key);
  const newState = {
    ...existingState,
    ...value,
  };
  localStorage.setItem(key, JSON.stringify(newState));
};
export const removeItem = (key = storageKeys.oat) => localStorage.removeItem(key);

export const setItemWithExpiry = (value, key, length) => {
  const time = new Date();
  const newState = {
    value,
    expiry: time.getTime() + length,
  };
  localStorage.setItem(key, JSON.stringify(newState));
};

export const getItemWithExpiry = (key = storageKeys.oat) => {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};

export const removeAllItems = () => {
  Object.values(storageKeys).forEach((key) => removeItem(key));
};

export { storageKeys };
